module.exports = __webpack_public_path__ + "static/media/T3.b87ca2ae.jpg";